const API_BASE_URL = process.env.REACT_APP_VENDOR_API || "https://api.cupvisor.org/v2/vendor";

export async function listVendors(getToken) {
  const res = await fetch(API_BASE_URL, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${await getToken()}`,
    },
  });
  if (!res.ok) throw new Error(`List vendors failed: ${res.status}`);
  const data = await res.json();
  return Array.isArray(data) ? data : data?.vendors || [];
}

export async function createVendor(payload, getToken) {
  const res = await fetch(API_BASE_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${await getToken()}`,
    },
    body: JSON.stringify(payload),
  });
  if (res.status !== 201) {
    const txt = await res.text();
    throw new Error(`Create failed: ${res.status} ${txt}`);
  }
  return res.json();
}

export async function updateVendor(vendorId, payload, getToken) {
  const res = await fetch(`${API_BASE_URL}?vendorId=${vendorId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${await getToken()}`,
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`Update failed: ${res.status} ${txt}`);
  }
  return res.json();
}

export async function deleteVendor(vendorId, getToken) {
  const res = await fetch(`${API_BASE_URL}?vendorId=${vendorId}`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${await getToken()}`,
    },
  });
  if (!res.ok) {
    const txt = await res.text();
    throw new Error(`Delete failed: ${res.status} ${txt}`);
  }
  return res.text();
}
